import React, { useEffect, useRef } from 'react';
import { ScrollView } from 'react-native-web';
import { Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { Button, BodyText } from '../../../ui';
import analytics from '../../../../modules/analytics';

type NameAndIndex = {
  name: string;
  index: number;
};

export type ServiceCategoryPillsProps = {
  inOverlay?: boolean;
  activeTabIndex: number;
  onTabChange: (newIndex: number) => void;
  serviceGroups: ReadonlyArray<NameAndIndex>;
};

export const ServiceCategoryPills: React.FCWithChildren<ServiceCategoryPillsProps> = ({
  inOverlay, serviceGroups, activeTabIndex, onTabChange,
}) => {
  const pillElementArray = useRef<Array<HTMLElement>>(Array(serviceGroups.length));

  useEffect(() => {
    const tabEl = pillElementArray.current[activeTabIndex];
    if (tabEl && inOverlay) {
      tabEl.scrollIntoView();
    }
  }, [
    activeTabIndex,
    inOverlay,
  ]);

  return (
    <ScrollView horizontal>
      <Inline paddingY={4}>
        {serviceGroups.map((item, idx) => (
          <Inline key={`${item.name}-${item.index}`} padding={4} space={2}>
            <Button
              style={{
                borderRadius: 20,
                borderWidth: 1,
                padding: '2px 8px',
                backgroundColor: idx === activeTabIndex
                  ? BrandColor.LightBlue
                  : BrandColor.Transparent,
              }}
              onClick={() => {
                analytics.track('client_seeallservices_clicked_category_tab', {
                  category_tab_name: item.name,
                  in_seeallservices_overlay: inOverlay,
                });
                onTabChange(idx);
              }}
              size="medium"
            >
              <Inline paddingY={8}>
                <BodyText textTransform="none">
                  {item.name}
                  <span ref={spanEl => { pillElementArray.current[idx] = spanEl; }} />
                </BodyText>
              </Inline>
            </Button>
          </Inline>
        ))}
      </Inline>
    </ScrollView>
  );
};

ServiceCategoryPills.defaultProps = {
  inOverlay: false,
};
